import { z } from 'zod';

export const ParticipantRoleSchema = z.enum(['from', 'to', 'cc', 'bcc', 'group']);
export type ParticipantRole = z.infer<typeof ParticipantRoleSchema>;

export const EventParticipantSchema = z.object({
  role: ParticipantRoleSchema,
  name: z.string().optional(),
  email: z.string().optional(),
  handle: z.string().optional(),
  personId: z.string().optional(),
  isSelf: z.boolean().optional(),
});
export type EventParticipant = z.infer<typeof EventParticipantSchema>;
